import { useQuery } from '@tanstack/react-query';

import { getInvitationDetails } from 'src/api';
import { invitationKeys } from 'src/utils/query-keys';
import { isSuccessResponse } from 'src/utils/response-type-guards';

export const useInvitationDetails = (invitationId: string | null) => {
  const { data, isLoading, isError } = useQuery({
    queryKey: invitationKeys.detail(invitationId),
    queryFn: () => getInvitationDetails(invitationId as string),
    enabled: !!invitationId,
    retry: 1,
    gcTime: 0,
    staleTime: 0,
  });

  const invitation = data && isSuccessResponse(data) ? data : null;

  return {
    invitation,
    isLoading,
    isError: isError || (!!data && !invitation),
  };
};
